import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSelector from '../../components/LanguageSelector';

type CheckEmailState = {
  email?: string;
  flow?: 'normal' | 'ads';
  returnTo?: string;
};

const CheckEmail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const state = location.state as CheckEmailState | null;

const email = state?.email || '';

const flow =
  state?.flow ||
  sessionStorage.getItem('registrationFlow') ||
  'normal';

const returnPage =
  state?.returnTo ||
  (flow === 'ads' ? '/ads-home' : '/');

  
  const [showLanguage, setShowLanguage] = React.useState(false);

  return (
    <div style={{ textAlign: 'center', marginTop: '140px', color: '#bbb' }}>
      {/* 🌐 Language Button */}
      <div style={{ position: 'absolute', top: '20px', right: '20px' }}>
        <button
          onClick={() => setShowLanguage(true)}
          style={{
            border: 'none',
            background: 'none',
            cursor: 'pointer',
            fontSize: '16px',
          }}
        >
          🌐 {t('language')}
        </button>
        {showLanguage && <LanguageSelector onClose={() => setShowLanguage(false)} />}
      </div>

      <h2>📥 {t('checkEmail.title')}</h2>
      <p style={{ marginTop: '20px' }}>
        {t('checkEmail.subtitle')} <strong>{email}</strong>
      </p>
      <p style={{ marginTop: '10px' }}>{t('checkEmail.note')}</p>

      <button
        onClick={() => navigate(returnPage)}
        style={{
          marginTop: '30px',
          padding: '10px 20px',
          backgroundColor: 'rgb(56, 6, 117)',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        {t('checkEmail.returnButton')}
      </button>
    </div>
  );
};

export default CheckEmail;
